import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {AreaModel} from '../../../../store/control/state';
import {useFilterSelector} from '../../../../hooks/filter-selector';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: AreaModel) => item.id;

export const AREA_TYPES = {
    'floor': 'floor',
    'place': 'place',
};

export const AreaListScreen = memo(function AreaListScreen() {
    const {t} = useLocalization();
    const [selected, setSelected] = useState<AreaModel>(null);

    const areaList = useFilterSelector(
        state => state.control.areaList,
        area => area.type === 'floor' || area.type === 'place',
        [],
    );

    const buttons = useMemo(() => [
        {
            text: t('room_list'),
            className: 'blue',
            url: selected != null ? `/settings/floor/${selected.id}/room` : '',
            hidden: !(selected && selected.type === 'floor'),
        },
        {
            text: t('edit'),
            url: `/settings/area/edit/${selected ? selected.id : ''}`,
            className: 'orange',
            hidden: !(selected),
        },
        {
            text: t('create_area'),
            url: '/settings/area/edit',
            className: 'green',
        },
    ], [t, selected]);

    const displayNameExtractor = useCallback((item: AreaModel, column: ColumnModel) => {
        if (column.key === 'type') {
            return t(AREA_TYPES[item.type]) || '-';
        }

        return item[column.key];
    }, [t]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('area_name'),
            key: 'name',
        },
        {
            length: 3,
            name: t('type'),
            key: 'type',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='service' isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} backUrl='/settings'>
                <SettingsList
                    columns={columns}
                    items={areaList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selected}
                    onItemSelected={setSelected}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
